import React, { memo, useMemo } from 'react'
import Card from 'transfix-ui/components/Card'
import { Divider } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import ShipmentOfferRow from 'apps/fleet-planner/pages/offers/components/ShipmentOfferRow'
import { HOMEPAGE_BOX_SHADOW, TEST_IDS } from '../../../constants'
import ShipmentOffersEmpty from '../ShipmentOffersEmpty'
import { ICurrentOfferedShipmentFragment } from '../graphql/CurrentOfferedShipmentFragment'

export interface IShipmentOffersCardProps {
  /**
   * @default false
   */
  loading?: boolean
  /**
   * @default []
   */
  offeredShipments: ICurrentOfferedShipmentFragment[]
  onDeclineSuccess?: () => void
}

const useShipmentOffersCardStyles = makeStyles(theme => ({
  card: {
    borderRadius: theme.spacing(0.5),
    boxShadow: HOMEPAGE_BOX_SHADOW,
    overflow: 'hidden',
  },
  divider: {
    margin: 0,
    borderBottom: `1px solid ${brandColors.coolGray2}`,
  },
}))

const ShipmentOffersCard = memo<IShipmentOffersCardProps>(
  ({ offeredShipments = [], loading = false, onDeclineSuccess }) => {
    const styles = useShipmentOffersCardStyles()

    const showRows = useMemo(() => {
      if (loading) {
        return false
      }
      return offeredShipments.length > 0
    }, [loading, offeredShipments])

    return (
      <Card className={styles.card} data-test={TEST_IDS.shipmentOffersCard} noPadding>
        {showRows ? (
          <>
            {offeredShipments.map((shipment, key) => {
              const { id } = shipment
              const showDivider = key < offeredShipments.length - 1
              return (
                <div key={id}>
                  <ShipmentOfferRow
                    offeredShipment={shipment}
                    onDeclineSuccess={onDeclineSuccess}
                  />
                  {showDivider && <Divider className={styles.divider} />}
                </div>
              )
            })}
          </>
        ) : (
          <ShipmentOffersEmpty loading={loading} />
        )}
      </Card>
    )
  }
)

export default ShipmentOffersCard
